import { useConversationCompactionStore } from "@/stores/conversation-compaction-store";

/** The companion's idle-compaction timeout when an event names none. */
const DEFAULT_COMPACTION_TIMEOUT_SECONDS = 60;

/**
 * Applies a `runtime.compaction` browser event: "started" shows the
 * conversation's "Compacting context…" note, "finished" clears it. The saved
 * "Compacted earlier context…" system message arrives separately as a normal
 * `message.created`.
 */
export function applyRuntimeCompaction(data: Record<string, unknown>): void {
  const conversationId = data.conversation_id;
  if (typeof conversationId !== "string" || !conversationId) return;
  const store = useConversationCompactionStore.getState();
  if (data.phase === "started") {
    const timeoutSeconds =
      typeof data.timeout_seconds === "number" &&
      Number.isFinite(data.timeout_seconds)
        ? data.timeout_seconds
        : DEFAULT_COMPACTION_TIMEOUT_SECONDS;
    store.start(conversationId, timeoutSeconds);
  } else if (data.phase === "finished") {
    store.finish(conversationId);
  }
}
